export const collectionTypes = [
  {
    value: 'Appeal Fee for Accused Appellant - Sec. 8(f)',
    label: 'Appeal Fee for Accused Appellant - Sec. 8(f)',
  },
  {
    value: 'Appeal Fee for Barangay or Sangguniang Kabataan Election Contests - Sec. 9, AM No. 07-4-15-SC dtd. Aug. 29, 2023',
    label: 'Appeal Fee for Barangay or Sangguniang Kabataan Election Contests - Sec. 9, AM No. 07-4-15-SC dtd. Aug. 29, 2023',
  },
  {
    value: 'Appeal Fee for Civil Case/Complainant - Sec. 8(f)',
    label: 'Appeal Fee for Civil Case/Complainant - Sec. 8(f)',
  },
  {
    value: 'Application/Motion for TRO and/or Injunction - Item a(iii) of AM No. 17-12-09-SC dated 10 January 2018 (OCA Cir. No. 36-2018)',
    label: 'Application/Motion for TRO and/or Injunction - Item a(iii) of AM No. 17-12-09-SC dated 10 January 2018 (OCA Cir. No. 36-2018)',
  },
  {
    value: 'Certificate of Sale (Sec. 21(d)) and Commission on Highest Bid Amount (Sec. 10(L))',
    label: 'Certificate of Sale (Sec. 21(d)) and Commission on Highest Bid Amount (Sec. 10(L))',
  },
  {
    value: 'Certificate of Sale (Sec. 21(d)) and Commission on Highest Bid Amount (Sec. 10(L)) - NO MONEY TO BE DEPOSITED',
    label: 'Certificate of Sale (Sec. 21(d)) and Commission on Highest Bid Amount (Sec. 10(L)) - NO MONEY TO BE DEPOSITED',
  },
  {
    value: 'Clearance and Certification Fee (Sec. 8(o)) with/out Certified Copies (Sec. 8(k))',
    label: 'Clearance and Certification Fee (Sec. 8(o)) with/out Certified Copies (Sec. 8(k))',
  },
  {
    value: 'Clearance and Certification Fee (Sec. 8(o)) with Search Fee and with/out Certified Copies (Sec. 8(k))',
    label: 'Clearance and Certification Fee (Sec. 8(o)) with Search Fee and with/out Certified Copies (Sec. 8(k))',
  },
  {
    value: 'Filing of Indemnity or Security Cash Bond/s in Provisional Remedy - Sec. 10(f)',
    label: 'Filing of Indemnity or Security Cash Bond/s in Provisional Remedy - Sec. 10(f)',
  },
  {
    value: 'For entries of Final Deed of Sale - Sec. 21(d)',
    label: 'For entries of Final Deed of Sale - Sec. 21(d)',
  },
  {
    value: 'Motion for 1st Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
    label: 'Motion for 1st Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
  },
  {
    value: 'Motion for 2nd Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
    label: 'Motion for 2nd Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
  },
  {
    value: 'Motion for 3rd Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
    label: 'Motion for 3rd Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
  },
  {
    value: 'Motion for 4th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
    label: 'Motion for 4th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
  },
  {
    value: 'Motion for 5th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
    label: 'Motion for 5th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
  },
  {
    value: 'Motion for 6th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
    label: 'Motion for 6th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
  },
  {
    value: 'Motion for 7th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
    label: 'Motion for 7th Postponement Fee for Multiple Cases - Sec. 21(b)(1)',
  },
  {
    value: 'Motion for Postponement Fee per Case - Sec. 21(b)(1)',
    label: 'Motion for Postponement Fee per Case - Sec. 21(b)(1)',
  },
  {
    value: 'Payment of Bond Fee only - Sec. 21(c)',
    label: 'Payment of Bond Fee only - Sec. 21(c)',
  },
  {
    value: 'Reception of Evidence by the Clerk of Court - Sec. 21(e)',
    label: 'Reception of Evidence by the Clerk of Court - Sec. 21(e)',
  },
]
